<template>
  <header>
    <a href="https://interval-strasbourg.eu/" target="_self"
      ><img src="../assets/images/logo-interval.svg" alt="Logo de Interval"
    /></a>
    <ul>
      <li>
        <a
          href="https://interval-strasbourg.eu/interval-association-inter-entreprises/"
          target="_self"
          >L'association</a
        >
      </li>
      <li>
        <a
          href="https://interval-strasbourg.eu/valparc-zone-tertiaire-vivante/"
          target="_self"
          >La zone d'activité</a
        >
      </li>
      <li>
        <a
          href="https://interval-strasbourg.eu/les-actualites/"
          target="_self"
          >Actualités</a
        >
      </li>
      <li>
        <a
          href="https://interval-strasbourg.eu/les-entreprises-adherentes/"
          target="_self"
          >Les adhérents</a
        >
      </li>
      <li>
        <a
          class="active"
          href="https://interval-strasbourg.eu/map/"
          target="_self"
          >Carte interactive</a
        >
      </li>
      <li>
        <a
          class="button"
          href="https://interval-strasbourg.eu/adherer/"
          target="_self"
          >Adhérer</a
        >
      </li>
    </ul>
    <a href="https://interval-strasbourg.eu/" class="quit-map"
      >Retour au site</a
    >
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss">
header {
  flex: 0 0 auto;
  width: 100%;
  height: 80px;
  margin: 0;
  padding: 25px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  background-color: #ffffff;
  @media (min-width: 1024px) {
    padding: 25px 40px;
  }
  & > a {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    display: block;
    img {
      width: auto;
      max-width: 100%;
      height: 27px;
      display: block;
    }
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    gap: 50px;
    list-style: none;
    @media (max-width: 1024px) {
      display: none;
    }
    li {
      margin: 0;
      padding: 0;
      a::before {
        content: "";
        position: absolute;
        bottom: -0.1vw;
        left: 0;
        right: 0;
        height: 1px;
        background-color: #009640;
        transform-origin: bottom right;
        transform: scaleX(0);
        transition: transform ease 0.5s;
      }
      a:hover::before {
        transform-origin: bottom left;
        transform: scaleX(1);
      }
      a {
        margin: 0;
        padding: 0;
        position: relative;
        color: #1d1d1b;
        font-size: 14px;
        font-weight: 400;
        line-height: 19px;
        letter-spacing: 0.02em;
        text-decoration: none;
        white-space: nowrap;
        transition: ease 0.25s;
        &:hover {
          color: #009640;
          transition: ease 0.25s;
        }
      }
      a.active::before,
      a.active {
        color: #009640;
        transform-origin: bottom left;
        transform: scaleX(1);
      }
      a.button {
        padding: 12px 24px;
        color: #ffffff;
        border-radius: 100px;
        background-color: #1d1d1b;
        &::before {
          content: none;
        }
      }
    }
    li:hover a.button::before,
    li:hover a.button:hover::before {
      content: none;
    }
    li:hover a.button {
      color: #ffffff;
      text-decoration: none;
      background-color: #009640;
    }
  }
  .quit-map {
    display: none;
    margin: 0;
    padding: 10px 20px;
    // background-color: var(--lightGray);
    background-color: var(--black);
    color: var(--white);
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    &::before {
      content: "";
      width: 10px;
      height: 10px;
      margin-right: 8px;
      display: inline-block;
      position: relative;
      background-image: url("../assets/images/icons/icon-arrow.svg");
      background-size: 10px;
      background-repeat: no-repeat;
      background-position: center center;
      filter: invert(1);
    }
    @media (max-width: 1024px) {
      display: block;
    }
  }
}
</style>
